
import { defineComponent } from 'vue';
import { map } from 'lodash';
import breakpointsState from '../breakpoints/breakpoints-state.observable';

// Define as many slots you want with their 'name' set to breakpoints:
// <breakpoints>
//   <div #sm>
//      sm only
//   </div>
//   <div #min-md,max-xl>
//     yy
//   </div>
//   <div #not-xs,not-md,max-xl>
//     for all except md and xs
//   </div>
// </breakpoints>

export default defineComponent({
    name: 'Breakpoints',
    setup(props, { slots }) {
        if (!slots) {
            throw new Error('You must provide at least 1 slot');
        }

        return () => {
            const visibleSlots = map(slots, (slot, key) => {
                return {
                    visible: breakpointsState.isBreakpointActive(key),
                    slot,
                };
            })
                .filter(x => x.visible)
                .map(x => x.slot);
            return visibleSlots.length ? visibleSlots![0]() : undefined;
        };
    },
});
